import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { installMockApi } from './mocks'

import '@/styles/base.css'

// Must run before the first request is made, and never in a build where the flag is off.
installMockApi()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
